import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import { OptionalHolidayUnderTeamColumns } from "../../tableColumns/table-columns";
import { OptionalHolidayJson } from "../../DynamicFormsJson/Transaction/optionalHoliday";
import { withRouter } from "../../components/withRouter";
import { compose } from "recompose";
import { getOptionalHolidaysForSalesTeam } from "../../Slice/year.slice";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";

class OptionalHolidayForUnderTeam extends React.Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        this.getData();
    }


    getData = async () => {
        const { getOptionalHolidaysForSalesTeam, showLoador, showNotification } =
            this.props;
        if (navigator.onLine) {

            const selfId = localStorage.getItem("userId");

            showLoador({ loador: true });
            await getOptionalHolidaysForSalesTeam({ salesTeamId: selfId }).then(({ success }) => {
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                }
            });
            showLoador({ loador: false });

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }

    render() {
        const { optionalHolidayList } = this.props;
        return (
            <>
                <DynamicMainScreen
                    callApi={false}
                    formPath={OptionalHolidayJson.formPathForSalesTeam}
                    screenTitle={"Optional Holiday Under Team"}
                    fieldMeta={OptionalHolidayJson.fieldMeta}
                    showPdfDownload={false}
                    showExcelDownload={true}
                    changeExcelURL={OptionalHolidayJson.excelUrl}
                    showExtension={false}
                    filterDataExcel={true}
                    pdfFileName={OptionalHolidayJson.pdfFileName}
                    excelFileName={OptionalHolidayJson.excelFileName}
                    showAddButton={true}
                    tableColumnsToFilter={OptionalHolidayJson.tableColumnsToFilterForSalesTeam}
                    tableColumns={OptionalHolidayUnderTeamColumns}
                    tableData={optionalHolidayList?.optionalHoliday}
                    getTableData={this.getData}
                    apiBaseURL={OptionalHolidayJson.apiBaseURL}
                    baseIdColumn={OptionalHolidayJson.baseIdColumn}
                    showDeleteIcon={false}
                    showViewButtonInTable={true}
                    formPathView={OptionalHolidayJson.formPathView}
                    showEditIcon={false}
                    isActionColActive={false}
                    addTitle={"Holiday"}
                    showBackButtonOnTable={true}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    optionalHolidayList: state.year,
});
const mapDispatchToProps = {
    getOptionalHolidaysForSalesTeam,
    showLoador,
    showNotification,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(OptionalHolidayForUnderTeam);
